import routerOptions0 from "/usr/src/app/content/n3-spas-756fb472-513d-45bf-8a81-961c78efa2d0/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}